import React from 'react';
import Layout from '../components/Layout';
import CenterList from '../components/CenterList';

/**
 * Página de listado de centros logísticos
 * Utiliza el componente Layout para mantener la estructura consistente
 * y el componente CenterList para mostrar la lista de centros
 */
const Centers = () => {
  return (
    <Layout>
      <CenterList />
    </Layout>
  );
};

export default Centers;
